<div class="min-h-screen flex items-center justify-center">
  <p-toast></p-toast>
  <div class="flex flex-wrap justify-center gap-5 my-5" [class.opacity-50]="!canSelectPackage" [class.pointer-events-none]="!canSelectPackage">
    <div *ngFor="let plans of this.listOfPlans">
      <div class="flex flex-col rounded-xl  border-purple-600 border-2 p-8 text-center min-w-[320px] max-w-[320px] ">
        <h4 class="">{{ plans.item_price.name }}</h4>
        <span class="mt-5 text-5xl font-bold ">
          <span>{{ plans.item_price?.price ? convertNumber(plans.item_price.price) : '0,00' }} €</span>
        </span>
        <p class="mt-2 text-sm text-gray-500 dark:text-neutral-500" i18n>Per User</p>
        <ul class="mt-7 space-y-2.5 text-sm">
          <li class="flex gap-x-2">
            <svg class="mt-0.5 size-4 shrink-0 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span class="text-gray-800 dark:text-neutral-400" i18n> Single user </span>
          </li>
          <li class="flex gap-x-2">
            <svg class="mt-0.5 size-4 shrink-0 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span class="text-gray-800 dark:text-neutral-400" i18n> Unlimited itineraries </span>
          </li>
          <li class="flex gap-x-2">
            <svg class="mt-0.5 size-4 shrink-0 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span class="text-gray-800 dark:text-neutral-400" i18n> All-features included </span>
          </li>
          <li class="flex gap-x-2">
            <svg class="mt-0.5 size-4 shrink-0 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span class="text-gray-800 dark:text-neutral-400" i18n> 7-day trial </span>
          </li>
          <li class="flex gap-x-2">
            <svg class="mt-0.5 size-4 shrink-0 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span class="text-gray-800 dark:text-neutral-400" i18n> Email support </span>
          </li>
        </ul>
        <button pButton class="mr-2 mt-5" (click)="this.createdHostedPage(plans.item_price.id)"
          [loading]="buttonLoadingStates[plans.item_price.id]" 
          [disabled]="buttonLoadingStates[plans.item_price.id] || !canSelectPackage"
          i18n-label
          label="Subscribe">
        </button>
      </div>
    </div>
  </div>

  <!-- Terms and Conditions Modal -->
  <app-terms-conditions-modal
    [(visible)]="showTermsModal"
    (accepted)="onTermsAccepted()"
    (visibleChange)="onTermsModalVisibleChange($event)">
  </app-terms-conditions-modal>
</div>